import {createContext, useContext} from 'react';
import {AttendanceTrackerSession} from '../../backend/responses/attendance-tracker-session';

export type AttendanceTrackerStatusContextType = {
  /** Whether the status was already obtained from the server */
  isLoaded: boolean;
  /** The open session (an entry without exit) of the logged user, if any */
  openSession?: AttendanceTrackerSession;
  /** ISO string. Current time of the server, to know how long the open session is running */
  serverTime?: string;
  /** Gets the status again, e.g. after registering an entry or an exit */
  refresh: () => Promise<void>;
};

export const AttendanceTrackerStatusContext = createContext<AttendanceTrackerStatusContextType>({
  isLoaded: false,
  refresh: async () => {},
});

export const useAttendanceTrackerStatus = () => useContext(AttendanceTrackerStatusContext);
